<template>
    <teleport to="body">
        <div
            ref="playMenuRef"
            v-show="showPlayMenu"
            class="bg-white shadow-lg rounded text-sm z-[100000]"
        >
            <div
                v-if="isPlay && !disableSave"
                class="
                    py-2
                    px-3
                    my-1
                    hover:bg-gray-100
                    cursor-pointer
                    flex
                    items-enter
                    gap-2
                "
                @click="handleAction({ action: 'overwrite' })"
            >
                <img
                    data-v-4657c487=""
                    src="/default-images/whiteboard/nav-save.svg"
                    alt="Save"
                    width="15"
                />
                <span v-if="isTemplate"
                    >Save Template "{{ play.play_name }}"</span
                >
                <span v-else>Save Play "{{ play.play_name }}"</span>
            </div>
            <div
                class="
                    py-2
                    px-3
                    my-1
                    hover:bg-gray-100
                    cursor-pointer
                    flex
                    items-enter
                    gap-2
                "
                @click="handleAction({ action: 'new' })"
            >
                <img
                    data-v-4657c487=""
                    src="/default-images/whiteboard/nav-save.svg"
                    alt="Save"
                    width="15"
                />
                <span v-if="isTemplate">Save Template As...</span>
                <span v-else>Save Play As...</span>
            </div>
            <load-video-modal
                v-if="!disableSave && !isTemplate"
                :video-api="videoApi"
                :video-group-api="videoGroupApi"
                :whiteboard-api="whiteboardApi"
                :play="loadState.activePlay"
                @loaded="showPlayMenu = false"
                @tagged="triggerVideoTagged"
                @saved="tempSaveTagVideo"
                class="
                    py-2
                    px-3
                    my-1
                    hover:bg-gray-100
                    cursor-pointer
                    flex
                    items-center
                    gap-2
                "
            >
                <img
                    src="/default-images/whiteboard/tool-video.svg"
                    width="15"
                />
                Load Video...
            </load-video-modal>
            <div
                class="
                    py-2
                    px-3
                    my-1
                    hover:bg-gray-100
                    cursor-pointer
                    flex
                    items-center
                    gap-2
                "
                @click="toggleAction('toggleGamePlan')"
            >
                <ion-icon
                    name="american-football-outline"
                    role="img"
                    class="md hydrated"
                    aria-label="trophy outline"
                ></ion-icon>
                Game Plan
            </div>
            <div
                class="
                    py-2
                    px-3
                    my-1
                    hover:bg-gray-100
                    cursor-pointer
                    flex
                    items-center
                    gap-2
                "
                @click="toggleAction('togglePracticePlan')"
            >
                <img src="/default-images/menu-icons/plan.svg" width="15" />
                Practice Plan
            </div>
        </div>
    </teleport>
    <teleport to="body">
        <div class="fixed top-[6rem] left-[10px] z-[1002]">
            <button
                class="flex justify-center items-center w-full my-4"
                @click="
                    handleAction({
                        action:
                            loadState.activePlay || props.isPlay
                                ? 'overwrite'
                                : 'new',
                    })
                "
            >
                <img src="/default-images/whiteboard/nav-save.svg" alt="Save" />
            </button>

            <button
                class="
                    w-9
                    h-9
                    flex
                    items-center
                    justify-center
                    rounded-full
                    shadow-xl
                    p-2
                    border border-gray-300
                    hover:scale-105 hover:bg-gray-200
                    transition
                    mb-4
                "
                type="button"
                @click="handleAction({ action: 'playdrawer' })"
            >
                <ion-icon name="list-outline"></ion-icon>
            </button>
            <button
                ref="playButtonRef"
                @click="togglePlayMenu(!showPlayMenu)"
                class="
                    w-9
                    h-9
                    flex
                    items-center
                    justify-center
                    rounded-full
                    shadow-xl
                    p-2
                    border border-gray-300
                    hover:scale-105 hover:bg-gray-200
                    transition
                "
            >
                <img src="/default-images/icons/play.png" alt="" />
            </button>
            <button
                v-if="!disableSave"
                class="
                    w-9
                    h-9
                    flex
                    items-center
                    justify-center
                    rounded-full
                    shadow-xl
                    p-2
                    border border-gray-300
                    hover:scale-105 hover:bg-gray-200
                    transition
                    mt-4
                "
                type="button"
                @click="handleAction({ action: 'background' })"
            >
                <img
                    src="/default-images/icons/background.png"
                    alt="Choose Background"
                />
            </button>

            <div
                class="flex flex-col items-center gap-4 pt-4"
                v-if="preview.mode != 'play-fullscreen'"
            >
                <button
                    class="border-none bg-none"
                    :class="{
                        'btn-mode-active': preview.mode == m,
                    }"
                    @click="changePreviewMode(m)"
                    v-for="m in modes"
                    :key="m"
                >
                    <img
                        :src="`/default-images/icons/${m}.png`"
                        alt="Video on top"
                        class="w-[24px] md hydrated"
                        role="img"
                        :aria-label="m"
                    />
                </button>
            </div>
        </div>

        <whiteboard-play-drawer
            :title="playDrawer.title"
            :is-open="playDrawer.isOpen"
            :active-play="loadState.activePlay"
            :team-id="props.teamId"
            @close="playDrawer.isOpen = false"
            @loadPlay="openPlayLink"
            @loadTemplate="openPlayLink"
        />
    </teleport>
    <ModalCustom
        :is-open="backgroundState.isBackgroundModalOpen"
        @close="backgroundState.isBackgroundModalOpen = false"
        title="Load Background"
        key="background"
        z-index="1002"
    >
        <div
            class="
                flex flex-wrap
                gap-8
                justify-start
                max-h-[50vh]
                overflow-y-auto
            "
        >
            <div
                class="
                    text-center
                    p-2
                    max-w-[300px]
                    flex flex-col
                    gap-2
                    hover:bg-gray-100
                    rounded-lg
                    items-center
                    justify-center
                    border-primary
                    text-primary
                    border-dashed border
                    cursor-pointer
                "
                key="none"
                @click="loadBackground({ name: 'None', image: 'none' })"
            >
                <div class="px-16">CLEAR BACKGROUND</div>
            </div>
            <div
                class="contents"
                v-for="(backgrounds, key) in backgroundState.backgrounds"
                :key="key"
            >
                <hr class="w-full" v-if="key != 0" />
                <div
                    class="
                        text-center
                        p-2
                        max-w-[300px]
                        flex flex-col
                        gap-2
                        hover:bg-gray-100
                        rounded-lg
                        border-gray-300 border
                        cursor-pointer
                    "
                    v-for="background in backgrounds"
                    :key="background.name"
                    @click="loadBackground(background)"
                >
                    <img :src="background.image" :alt="background.name" />
                    <div>
                        {{ background.name }}
                    </div>
                </div>
            </div>
        </div>
    </ModalCustom>
    <ModalCustom
        :is-open="saveState.isSaveModalOpen"
        @close="tryCloseSaveModal"
        :title="isTemplate ? 'Save Template' : 'Save Play'"
    >
        <div>
            <form
                method="post"
                :action="playSaveApi"
                @submit.prevent="savePlay"
            >
                <input type="hidden" name="_token" :value="$root.csrfToken" />
                <input type="hidden" name="link" :value="code" />
                <input
                    type="hidden"
                    name="is_template"
                    value="1"
                    v-if="isTemplate"
                />

                <app-input
                    maxlength="120"
                    name="play_name"
                    placeholder="Play name (max 120 chars)"
                    type="text"
                    required
                    v-model="saveState.playName"
                    :readonly="saveState.askOverwrite"
                ></app-input>
                <div class="mt-2">
                    <app-select
                        name="playbook_id_select"
                        :disabled="saveState.askOverwrite"
                        v-model="saveState.selectedPlaybook"
                    >
                        <option
                            v-for="playbook in saveState.playbooks"
                            :value="playbook.playbook_id"
                            :key="playbook.playbook_id"
                        >
                            {{ playbook.playbook_title }}
                        </option>
                    </app-select>
                    <input
                        type="hidden"
                        name="playbook_id"
                        :value="saveState.selectedPlaybook"
                    />
                </div>
                <div class="flex items-center mt-4 gap-4">
                    <div
                        v-if="saveState.askOverwrite"
                        class="
                            p-2
                            rounded
                            bg-red-200
                            text-red-700
                            STORAGE:
                            35
                            MB
                            available
                            space
                            flex-grow-1 flex-shrink-0
                            text-sm
                        "
                    >
                        There's already play with the same name on this
                        playbook. Overwrite?
                    </div>
                    <app-button
                        v-if="saveState.askOverwrite"
                        type="button"
                        class="flex-grow-0 flex-shrink-0 ml-auto"
                        @click="cancelOverwrite"
                    >
                        Cancel
                    </app-button>
                    <app-button
                        type="submit"
                        :disabled="saveState.isSaving"
                        class="
                            flex-grow-0 flex-shrink-0
                            ml-auto
                            bg-primary
                            text-white
                        "
                    >
                        {{
                            saveState.isSaving
                                ? "Saving..."
                                : saveState.askOverwrite
                                ? "Overwrite"
                                : "Save"
                        }}
                    </app-button>
                </div>
                <input
                    v-if="saveState.askOverwrite"
                    type="hidden"
                    name="is_overwrite"
                    :value="saveState.askOverwrite"
                />
            </form>
        </div>
    </ModalCustom>
</template>

<script setup>
import { computed, onMounted, reactive, ref, toRaw, watch } from "vue";
import AppInput from "./AppInput";
import ModalCustom from "./ModalCustom";
import WhiteboardMenuItem from "./WhiteboardMenuItem";
import AppButton from "./AppButton";
import { createPopper } from "@popperjs/core";
import LoadPlayModal from "./LoadPlayModal.vue";
import LoadVideoModal from "./LoadVideoModal.vue";
import WhiteboardPlayDrawer from "./WhiteboardPlayDrawer.vue";
import { truncateJson } from "../utils/play";
import { sleep } from "../utils/timer";
import emitter from "tiny-emitter/instance";
import useWhiteboard from "./whiteboard/useWhiteboard";
import {
    basketballBg,
    footballBg,
    soccerBg,
    hockeyBg,
    fieldHockeyBg,
    lacrosseBg,
    volleyballBg,
} from "./whiteboard/backgrounds";

const props = defineProps([
    "roomId",
    "disableSave",
    "playSaveApi",
    "playListApi",
    "playbookApi",
    "videoApi",
    "videoGroupApi",
    "whiteboardApi",
    "code",
    "previewUrl",
    "setBackgroundApi",
    "background",
    "isPlay",
    "isTemplate",
    "play",
    "playSetApi",
    "playClearApi",
    "notes",
    "sport",
    "teamId",
]);

const { modes, preview } = useWhiteboard();

const backgroundState = reactive({
    isBackgroundModalOpen: false,
    currentBackground: props.background,
    backgrounds: [],
});

const templateState = reactive({
    activeTemplateGroup: null,
    isTemplateModalOpen: false,
    templateGroups: [],
});

const saveState = reactive({
    isSaveModalOpen: false,
    isSaving: false,
    playbooks: [],
    askOverwrite: false,
    playName: "",
    selectedPlaybook: "-1",
    tempTagVideo: null,
});

const loadState = reactive({
    isLoadModalOpen: false,
    isLoading: false,
    selectedPlay: null,
    plays: [],
    playbooks: [],
    activePlaybook: -1,
    activePlay: props.play || null,
});

const playDrawer = reactive({
    isOpen: false,
    title: "Play Drawer",
});

function appendAnimationData(formData, animationData) {
    if (!props.isPlay || !animationData) return;
    formData.append("animation_json", JSON.stringify(animationData));
}

const loadTemplateTitle = computed(() => {
    if (templateState.activeTemplateGroup) {
        return templateState.activeTemplateGroup.playbook_title;
    }
    return "Load Template";
});

const playInActivePlaybook = computed(() => {
    if (!loadState.plays) {
        return [];
    }
    if (loadState.activePlaybook === -1) {
        return loadState.plays.filter((play) => play.playbook_id === null);
    }
    return loadState.plays.filter(
        (play) => play.playbook_id === loadState.activePlaybook
    );
});

const tryCloseLoadModal = () => {
    if (loadState.isLoading) {
        return;
    }

    saveState.tempTagVideo = null;
    loadState.isLoadModalOpen = false;
};

const handleAction = async (action) => {
    if (action.action === "new") {
        saveState.isSaveModalOpen = true;
    }
    if (action.action === "load") {
        await refreshData();
        loadState.isLoadModalOpen = true;
    }
    if (action.action === "template") {
        templateState.isTemplateModalOpen = true;
    }
    if (action.action === "background") {
        backgroundState.isBackgroundModalOpen = true;
    }
    if (action.action === "playdrawer") {
        playDrawer.isOpen = !playDrawer.isOpen;
    }
    if (action.action === "overwrite") {
        const formData = new FormData();
        if (loadState.activePlay) {
            formData.append("play_id", loadState.activePlay.play_id);
        } else {
            formData.append("play_id", props.play.play_id);
        }
        formData.append("background", backgroundState.currentBackground);
        const frame = document.getElementById("meeting_iframe");
        if (frame) {
            const messageListener = (event) => {
                if (!props.whiteboardApi.startsWith(event.origin)) return;
                if (event.data.action === "getBufferDataReply") {
                    formData.append(
                        "play_json",
                        JSON.stringify(truncateJson(event.data.data))
                    );
                    appendAnimationData(formData, event.data.animation);
                    formData.append("play_thumbnail", event.data.image);
                    if (props.isTemplate) {
                        formData.append("is_template", 1);
                    }
                    if (event.data.notes) {
                        formData.append("play_note", event.data.notes);
                    }
                    axios
                        .post(props.playSaveApi, formData)
                        .then((res) => {
                            saveState.isSaving = false;
                            saveState.isSaveModalOpen = false;
                            saveState.playName = "";

                            window.removeEventListener(
                                "message",
                                messageListener,
                                false
                            );
                        })
                        .catch(() => {
                            saveState.isSaving = false;
                            saveState.askOverwrite = true;
                            window.removeEventListener(
                                "message",
                                messageListener,
                                false
                            );
                        });
                }
            };
            window.addEventListener("message", messageListener, false);
            frame.contentWindow.postMessage(
                {
                    action: "getBufferData",
                },
                props.whiteboardApi
            );
        } else {
            emitter.once("getBufferDataReply", function (event) {
                formData.append("play_json", JSON.stringify(event.data));
                appendAnimationData(formData, event.animation);
                formData.append("play_thumbnail", event.image);
                if (props.isTemplate) {
                    formData.append("is_template", 1);
                }
                if (event.notes) {
                    formData.append("play_note", event.notes);
                }

                axios
                    .post(props.playSaveApi, formData)
                    .then((res) => {
                        saveState.isSaving = false;
                        saveState.isSaveModalOpen = false;
                        saveState.playName = "";
                    })
                    .catch(() => {
                        saveState.isSaving = false;
                        saveState.askOverwrite = true;
                    });
            });
            emitter.emit("getBufferData");
        }
    }
    showPlayMenu.value = false;
};

const tryCloseSaveModal = () => {
    if (!saveState.isSaving) {
        saveState.isSaveModalOpen = false;
    }
};
const savePlay = async (e) => {
    const formData = new FormData(e.target);
    e.preventDefault();
    if (props.isPlay && props.play.team_id) {
        formData.append("teamId", props.play.team_id);
    }
    formData.append("background", backgroundState.currentBackground);
    saveState.isSaving = true;
    const frame = document.getElementById("meeting_iframe");
    if (frame) {
        const messageListener = async (event) => {
            if (!props.whiteboardApi.startsWith(event.origin)) return;
            if (event.data.action === "getBufferDataReply") {
                formData.append(
                    "play_json",
                    JSON.stringify(truncateJson(event.data.data))
                );
                appendAnimationData(formData, event.data.animation);
                formData.append("play_thumbnail", event.data.image);
                if (loadState.activePlay) {
                    formData.append(
                        "prev_play_id",
                        loadState.activePlay.play_id
                    );
                } else if (props.isPlay) {
                    formData.append("prev_play_id", props.play.play_id);
                }
                try {
                    const res = await axios.post(e.target.action, formData);
                    saveState.isSaving = false;
                    saveState.isSaveModalOpen = false;
                    saveState.playName = "";
                    if (props.isPlay) {
                        if (res.data.play_id) {
                            window.location.href = `/plays/show?playId=${res.data.play_id}`;
                        }
                    }
                    if (saveState.tempTagVideo) {
                        await axios.post("/plays/tag-video", {
                            play_id: res.data.play_id,
                            video_id: saveState.tempTagVideo.id,
                        });
                        res.data.videos = [saveState.tempTagVideo];
                    }
                    triggerPlayLoaded(res.data);
                    window.removeEventListener(
                        "message",
                        messageListener,
                        false
                    );
                } catch (err) {
                    saveState.isSaving = false;
                    saveState.askOverwrite = true;
                    window.removeEventListener(
                        "message",
                        messageListener,
                        false
                    );
                    console.error(err);
                }
            }
        };
        window.addEventListener("message", messageListener, false);
        frame.contentWindow.postMessage(
            {
                action: "getBufferData",
            },
            props.whiteboardApi
        );
    } else {
        emitter.once("getBufferDataReply", async function (event) {
            formData.append("play_json", JSON.stringify(event.data));
            appendAnimationData(formData, event.animation);
            formData.append("play_thumbnail", event.image);

            if (loadState.activePlay) {
                formData.append("prev_play_id", loadState.activePlay.play_id);
            } else if (props.isPlay) {
                formData.append("prev_play_id", props.play.play_id);
            }
            try {
                const res = await axios.post(e.target.action, formData);
                saveState.isSaving = false;
                saveState.isSaveModalOpen = false;
                saveState.playName = "";
                if (props.isPlay) {
                    if (res.data.play_id) {
                        window.location.href = `/plays/show?playId=${res.data.play_id}`;
                    }
                }
                if (saveState.tempTagVideo) {
                    await axios.post("/plays/tag-video", {
                        play_id: res.data.play_id,
                        video_id: saveState.tempTagVideo.id,
                    });
                    res.data.videos = [saveState.tempTagVideo];
                }
                const play = res.data;
                emitter.emit("wb-video-tagged", play);
                loadState.activePlay = play;
                await axios.post(props.playSetApi, {
                    roomId: props.roomId,
                    playId: play.play_id,
                });
            } catch (err) {
                saveState.isSaving = false;
                saveState.askOverwrite = true;
                console.error(err);
            }
        });

        emitter.emit("getBufferData");
    }
};
const cancelOverwrite = () => {
    saveState.playName = "";
    saveState.askOverwrite = false;
};
const openPlayLink = async (selectedPlay) => {
    if (props.isPlay && !selectedPlay.is_template) {
        const url = new URL(window.location.href);
        url.searchParams.set("playId", selectedPlay.play_id);
        window.location.href = url.toString();
    } else if (selectedPlay.is_template) {
        loadTemplate(selectedPlay);
    } else {
        const data = await axios.get("/plays/get-play-data", {
            params: {
                play_id: selectedPlay.play_id,
            },
        });
        triggerPlayLoaded(data.data);
    }
};

const loadPlay = async (selectedPlay) => {
    const playData = loadState.plays.find(
        (play) => play.play_id === parseInt(selectedPlay.play_id)
    );
    const playJson = JSON.parse(playData.play_json);
    loadState.isLoading = true;
    try {
        const frame = document.getElementById("meeting_iframe");
        if (frame) {
            frame.contentWindow.postMessage(
                {
                    action: "play",
                    data: playJson,
                },
                props.whiteboardApi
            );
        }
    } catch {
        alert("Error loading play");
    }
    loadState.isLoading = false;
    loadState.isLoadModalOpen = false;
};

async function triggerPlayLoaded(play) {
    loadState.activePlay = play;
    await axios.post(props.playSetApi, {
        roomId: props.roomId,
        playId: play.play_id,
    });
    emitter.emit("wb-load-play", play);
}

async function triggerVideoTagged(play) {
    emitter.emit("wb-video-tagged", play);
}

emitter.on("clear-wb", function () {
    loadState.activePlay = null;
});

emitter.on("video-tagged-wb", function (play) {
    loadState.activePlay = play;
});

function toggleAction(action) {
    emitter.emit("whiteboard-toggle-action", action);
    showPlayMenu.value = false;
}

async function refreshData() {
    try {
        saveState.playbooks = (await axios.get(props.playbookApi)).data;
        loadState.playbooks = saveState.playbooks;

        if (loadState.playbooks && loadState.playbooks.length > 0) {
            saveState.selectedPlaybook = loadState.playbooks[0].playbook_id;
        }
    } catch {}

    try {
        const templateApiUrl = new URL(props.playbookApi);
        templateApiUrl.searchParams.set("isTemplate", 1);
        templateState.templateGroups = (
            await axios.get(templateApiUrl.href)
        ).data;
    } catch {}

    try {
        loadState.plays = (await axios.get(props.playListApi)).data;
        loadState.selectedPlay = loadState.plays?.[0]?.play_id;
    } catch {}
}

async function handleLoadTemplateFromDrawer(template) {
    const url = new URL(window.location.href);
    url.searchParams.set("playId", template.play_id);
    window.location.href = url.toString();
}

async function loadTemplate(template) {
    const dataTemplate = await axios.get("/plays/get-play-data", {
        params: {
            play_id: template.play_id,
        },
    });
    const frame = document.getElementById("meeting_iframe");
    if (frame) {
        const rawData = toRaw(JSON.parse(dataTemplate.data.play_json));
        const truncated = truncateJson(rawData);

        frame.contentWindow.postMessage(truncated, props.whiteboardApi);
    }
    if (
        dataTemplate.data.background &&
        dataTemplate.data.background !== "none"
    ) {
        loadBackground({ image: dataTemplate.data.background });
    }
    templateState.isTemplateModalOpen = false;
    templateState.activeTemplateGroup = null;
    emitter.emit("wb-load-template", dataTemplate.data);
}

async function loadBackground(background) {
    const frame = document.getElementById("meeting_iframe");
    if (frame) {
        frame.contentWindow.postMessage(
            {
                action: "background",
                background: window.origin + background.image,
            },
            props.whiteboardApi
        );
    }
    emitter.emit("wb-change-background", background.image);

    backgroundState.isBackgroundModalOpen = false;
    backgroundState.currentBackground = background.image;
    if (!props.isPlay) {
        await axios.post(props.setBackgroundApi, {
            roomId: props.roomId,
            background: background.image,
        });
    }
}

const showPlayMenu = ref(false);
const playMenuRef = ref(null);
const playButtonRef = ref(null);
const togglePlayMenu = (value) => {
    showPlayMenu.value = value;
    if (value) {
        createPopper(playButtonRef.value, playMenuRef.value, {
            placement: "right",
            modifiers: [
                {
                    name: "offset",
                    options: {
                        offset: [0, 8],
                    },
                },
            ],
        }).forceUpdate();
    }
};

const isMobile = () => {
    return (
        /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
            navigator.userAgent
        ) ||
        screen.availWidth < 768 ||
        screen.availHeight < 480
    );
};

function loadSportBackground() {
    if (props.sport === "basketball") {
        backgroundState.backgrounds = [
            basketballBg,
            footballBg,
            soccerBg,
            hockeyBg,
            fieldHockeyBg,
            lacrosseBg,
            volleyballBg,
        ];
    } else {
        backgroundState.backgrounds = [
            footballBg,
            basketballBg,
            soccerBg,
            hockeyBg,
            fieldHockeyBg,
            lacrosseBg,
            volleyballBg,
        ];
    }
}

onMounted(() => {
    refreshData();
    loadSportBackground();

    const frame = document.getElementById("meeting_iframe");
    frame?.addEventListener("load", () => {
        const pingId = crypto.randomUUID();
        const contentWindow = frame.contentWindow;
        const interval = setInterval(() => {
            contentWindow.postMessage(
                { action: "ping", id: pingId },
                props.whiteboardApi
            );
        }, 1500);
        const listener = (event) => {
            if (event.data.action === "pong" && event.data.id === pingId) {
                clearInterval(interval);
                window.removeEventListener("message", listener);
                frame.contentWindow.postMessage(
                    {
                        action: "background",
                        background:
                            window.origin + (props.background ?? "none"),
                    },
                    props.whiteboardApi
                );
            }
        };
        window.addEventListener("message", listener);
    });

    window.addEventListener("message", function (event) {
        // Unlink play with the whiteboard
        if (
            event.data.action === "clear" &&
            !props.isPlay &&
            loadState.activePlay
        ) {
            axios.post(props.playClearApi, {
                roomId: props.roomId,
            });
            loadState.activePlay = null;

            if (!props.isPlay) {
                frame?.contentWindow.postMessage(
                    {
                        action: "setVideosCount",
                        count: 0,
                    },
                    props.whiteboardApi
                );
            }
        }

        if (event.data.action === "load_background") {
            loadBackground(event.data);
        }
    });
});

function tempSaveTagVideo(video) {
    saveState.tempTagVideo = video;
    saveState.isSaveModalOpen = true;
}

function changePreviewMode(mode) {
    emitter.emit("change-preview-mode", mode);
}
</script>

<style scoped>
.btn-mode-active {
    border: 2px solid #ff7b52;
}
</style>
